import { render } from "./NoticeEdit.vue?vue&type=template&id=4ba42162&scoped=true"
import script from "./NoticeEdit.vue?vue&type=script&lang=js"
export * from "./NoticeEdit.vue?vue&type=script&lang=js"

import "./NoticeEdit.vue?vue&type=style&index=0&id=4ba42162&lang=scss&scoped=true"

import exportComponent from "/root/workspace/yatinjuryplatformwebcode_Vf1x/CODE/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4ba42162"]])

export default __exports__